// todo: ideally this and the navigation hierarchy would be one and the same, so we wouldn't need this mapping
import { PlanComponentPageKey } from "../types/PlanComponentPageKey";

export const planComponentPageKeyHrefMap: Record<PlanComponentPageKey, string> =
  {
    [PlanComponentPageKey.Scope1CutEnergyWaste]:
      "/plan/entry/scope1CutEnergyWaste",
    [PlanComponentPageKey.Scope1Electrify]: "/plan/entry/scope1Electrify",
    [PlanComponentPageKey.Scope1BuyClean]: "/plan/entry/scope1BuyClean",
    [PlanComponentPageKey.Scope1LessCommonSolutions]:
      "/plan/entry/scope1LessCommonSolutions",
    [PlanComponentPageKey.Scope2CutEnergyWaste]:
      "/plan/entry/scope2CutEnergyWaste",
    [PlanComponentPageKey.Scope2BuyClean]: "/plan/entry/scope2BuyClean",
  };
